// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Service.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { Column } from '../../../../../com/MetaPattern/MDA/MD/SiteModel/Column';
import { Website } from '../../../../../com/MetaPattern/MDA/MD/SiteModel/Website';
import { get } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/Request';
/**
 * 站点元数据服务 服务类
 * 站点元数据服务
 */
export class SiteMDService {
  static async GetSiteColumnsAsync(websiteCode: string): Promise<Array<Column> | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/sitemdservice/getsitecolumns', { websiteCode: websiteCode })
        .then((response: any) => {
          let result: Array<Column> | null = null;
          if (response) {
            const items = new Array<Column>();
            response.forEach((item: any) => {
              const element = Column.Create(item);
              if (item.Website !== null) {
                element.website = Website.Create(item.Website);
              }
              if (item.Parent !== null) {
                element.parent = Column.Create(item.Parent);
              }
              items.push(element);
            });
            result = items;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }
}
